export default "__VITE_PUBLIC_ASSET__cef489d5__"